// import { objToFormData } from '@/utils/form-data';
import * as http from './http-common';

class API {
  // A1
  static async login(params) {
    const options = {
      method: 'post',
      url: '/login/',
      data: params,
    };

    return http.auth(options);
  }

  // A2
  static async loginAs(params) {
    const options = {
      method: 'post',
      url: '/login-as/',
      params,
    };

    return http.auth(options);
  }

  static async logout() {
    const options = {
      method: 'post',
      url: '/logout/',
    };

    return http.auth(options);
  }

  // A4
  static async refresh(data) {
    const options = {
      method: 'post',
      url: '/refresh/',
      data,
    };

    return http.auth(options);
  }

  // A5
  static async verify(data) {
    const options = {
      method: 'post',
      url: '/me/',
      data,
    };

    return http.auth(options);
  }

  // Q1
  static async quizList() {
    const options = {
      method: 'get',
      url: '/quizzes/',
    };

    return http.quiz(options);
  }

  // Q2
  static async getQuiz(slug) {
    const options = {
      method: 'get',
      url: encodeURI(`/quizzes/${slug}/`),
    };

    return http.quiz(options);
  }

  // Q4
  static async getQuizSession() {
    const options = {
      method: 'get',
      url: '/quiz-sessions/get-active/',
    };

    return http.quiz(options);
  }

  // Q5
  static async checkActiveSessions() {
    const options = {
      method: 'post',
      url: '/quiz-sessions/check/',
    };

    return http.quiz(options);
  }

  // Q6
  static async createQuizSession(params) {
    const options = {
      method: 'post',
      url: '/quiz-sessions/',
      data: params,
    };

    return http.quiz(options);
  }

  // Q7
  static async startQuizSession() {
    const options = {
      method: 'post',
      url: '/quiz-sessions/start/',
    };

    return http.quiz(options);
  }

  // Q8
  static async completeQuizSession() {
    const options = {
      method: 'post',
      url: '/quiz-sessions/complete/',
    };

    return http.quiz(options);
  }

  // Q9
  static async answerQuestion(sessionQuestionId, answerId) {
    const params = {
      answer: answerId,
    };

    const options = {
      method: 'post',
      url: encodeURI(`/session-questions/${sessionQuestionId}/answer/`),
      data: params,
    };

    return http.quiz(options);
  }

  // Q10
  static async toggleQuestionBookmark(sessionQuestionId) {
    const options = {
      method: 'post',
      url: encodeURI(`/session-questions/${sessionQuestionId}/bookmark/`),
    };

    return http.quiz(options);
  }

  // Q11
  static async getLastSessionResults() {
    const options = {
      method: 'get',
      url: '/quiz-sessions/results/',
    };

    return http.quiz(options);
  }
}

export default API;
